var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
export class MalteseAdditionalInfoDetail {
  constructor(_data) {
    /**
     */
    __publicField(this, "SubmissionToken");
    /**
     */
    __publicField(this, "SubscriptionKey");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof MalteseAdditionalInfoDetail
     */
    __publicField(this, "$type", "V1.Cesop.Psps.Extensions.MalteseAdditionalInfoDetail");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.SubmissionToken = _data["SubmissionToken"];
      this.SubscriptionKey = _data["SubscriptionKey"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["SubmissionToken"] = this.SubmissionToken;
    _data["SubscriptionKey"] = this.SubscriptionKey;
    return _data;
  }
}
